import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const InEligible = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 15"
    fill="none"
    {...props}
  >
    <Path
      d="M16.4 13.07c0 .18-.15.33-.33.33H1.93c-.18 0-.33-.15-.33-.33V7.63h5.23c-.1-.47-.15-.95-.15-1.45V6H1.6V4.15c0-.18.15-.33.33-.33h5.16c.2-.57.46-1.11.79-1.6H1.93C.87 2.22 0 3.09 0 4.15v8.92C0 14.13.87 15 1.93 15h14.14c1.06 0 1.93-.87 1.93-1.93v-.95c-.49.34-1.03.62-1.6.83v.12Z"
      fill={color}
    />
    <Path
      d="M13.9.18c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Zm0 10.6a4.6 4.6 0 1 1 .001-9.201 4.6 4.6 0 0 1-.001 9.201Z"
      fill={color}
    />
    <Path
      d="M14.04 7.66a.852.852 0 0 0-.88.87c0 .24.08.45.25.62.17.17.37.25.63.25s.45-.08.62-.25a.83.83 0 0 0 .25-.62.83.83 0 0 0-.25-.62.83.83 0 0 0-.62-.25ZM14.04 2.96c-.28 0-.51.08-.69.23-.18.15-.27.36-.27.63v.14l.47 2.8c.02.16.08.28.17.36.09.08.19.13.32.13s.23-.04.32-.13c.09-.08.14-.2.16-.36L15 3.97v-.14c0-.27-.09-.48-.27-.64-.18-.16-.41-.23-.69-.23Z"
      fill={color}
    />
  </Svg>
)

export default InEligible
